import { FaPlug, FaBell, FaHistory, FaRobot } from "react-icons/fa";
import "./Automation.css";
import { MdDashboard, MdOutlineWorkspaces, MdPhoneIphone } from "react-icons/md";
import { HiOutlineUserGroup } from "react-icons/hi";

export default function AutomationFlow() {
  const features = [
     {
      icon: <MdDashboard />,
      title: "Dasboards",
      description:
        "Gain a real-time overview of your operations with a centralized dashboard. Monitor performance, track key metrics, and make smarter decisions faster with AI-powered insights.",
      link: "#",
    },
     {
      icon: <MdOutlineWorkspaces />,
      title: "Automated Workflows",
      description:
        "Transform your business processes with smart, adaptable workflows designed to eliminate manual tasks and significantly speed up cycle times.",
      link: "#",
    },
   
    {
      icon: <FaPlug />,
      title: "Powerful Integrations",
      description:
        "With powerful API capabilities, VENSAP connects effortlessly with legacy systems and ERP applications, creating a fully integrated digital environment.",
    },
     {
      icon: <HiOutlineUserGroup />,
      title: "Internal Collaboration",
      description:
        "Enhance cross-functional alignment by streamlining processes and enabling teams to collaborate seamlessly toward shared business objectives.",
      link: "#",
    },
    {
      icon: <FaBell />,
      title: "Smart Alerts & Reminders",
      description:
        "Set up intelligent notification rules for automated email alerts and reminders, keeping stakeholders informed and ensuring timely action.",
    },
     {
      icon: <MdPhoneIphone />,
      title: "Mobile App",
      description:
        "The VENSAP mobile app empowers our customers to manage their business from anywhere, at any time. Make important approval decisions remotely, monitor key operations in real time, and stay connected to your workflows on the go.",
      link: "#",
    },
    {
      icon: <FaHistory />,
      title: "Robust Logs & Traceability",
      description:
        "Track every action, approval, and partner interaction with detailed audit trails—enhancing transparency, accountability, and operational control.",
    },
    {
      icon: <FaRobot />,
      title: "AI Agents",
      description:
        "Powered by intelligent AI agents, VENSAP automates end-to-end business processes—empowering teams to achieve cost optimization, operational resilience, and continuous innovation.",
      link: "#",
    },
  ];

  return (
    <section className="services">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            Infuse your business processes with{" "}
            <span> speed, agility and intelligent,automation</span>
          </h2>
          <p>
            Modern businesses require a flexible platform that enables rapid
            adaptation to changing market conditions while seamlessly leveraging
            the latest technological advancements.
          </p>
        </div>

        <div className="services-grid">
          {features.map((item, index) => (
            <div key={index} className="service-item">
              <div className="service-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
